import { BlockStack, Spinner, Typography } from '@pv-frontend/ui-components-web';
import { Centered } from './centered';
import { useServiceStatus } from '../relay/use-service-status';

/**
 * Suspense fallback for the routed content. When the Admin fetch reports a
 * scale-to-zero cold start it shows the "waking the admin service…" copy;
 * otherwise a plain spinner while the query resolves.
 */
export function LoadingContent() {
    const status = useServiceStatus();
    const waking = status === 'waking';
    return (
        <Centered>
            <BlockStack gap="300" inlineAlign="center">
                <Spinner size="large" />
                <Typography tone="text-secondary">
                    {waking ? 'Waking the admin service…' : 'Loading…'}
                </Typography>
                {waking ? (
                    <Typography variant="body-sm" tone="text-secondary">
                        The admin service scales to zero when idle; this can take a few seconds.
                    </Typography>
                ) : null}
            </BlockStack>
        </Centered>
    );
}
